// src/components/RouteMeta.js
// Central place to mark private / transactional routes as noindex so search
// engines focus their crawl budget on the real content pages (home, products,
// about, testimonials, contact) and never index thin/duplicate pages like the
// cart, checkout or login. robots.txt already blocks most of these for crawlers
// that don't run JS; this is the belt-and-suspenders meta-level signal.
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const NOINDEX_PREFIXES = [
  '/account',
  '/orders',
  '/checkout',
  '/cart',
  '/wishlist',
  '/login',
  '/signup',
  '/forgot-password',
];

const RouteMeta = () => {
  const { pathname } = useLocation();
  const isPrivate = NOINDEX_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );

  if (!isPrivate) return null;

  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  );
};

export default RouteMeta;
